export default "__VITE_ASSET__BPdsCER5__"